import json from "@/data/copy/growth-features.json";
import { createCopyGetter } from "@/lib/localize-copy";
import type { Lang } from "@/lib/types";
import type { GrowthFeatureIntroCopy } from "./GrowthFeatureIntro";
import type { GrowthFeatureAiContentCardCopy } from "./growth-feature-ai-content-copy";
import type { GrowthFeatureAdPerformanceCardCopy } from "./growth-feature-ad-performance-copy";
import type { GrowthFeatureCampaignCardCopy } from "./growth-feature-campaign-copy";
import type { GrowthFeatureSeoAuditsCardCopy } from "./growth-feature-seo-audits-copy";

const resolveCopy = createCopyGetter(json);

export function getGrowthFeatureDefaults(lang: Lang): {
  intro: GrowthFeatureIntroCopy;
  aiContent: GrowthFeatureAiContentCardCopy;
  adPerformance: GrowthFeatureAdPerformanceCardCopy;
  campaign: GrowthFeatureCampaignCardCopy;
  seoAudits: GrowthFeatureSeoAuditsCardCopy;
} {
  return resolveCopy(lang) as ReturnType<typeof getGrowthFeatureDefaults>;
}
